import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import LoadingOverlay from "../../../shared/components/LoadingOverlay";
import ftosActionCreators from "../../store/ftos/action-creators";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import Modal from "../../../shared/ui/Modal";
import Checkbox from "../../../shared/forms/Checkbox";
import {Input} from "reactstrap";
import FtoStatistics from "./FtoStatistics";
import oitsActionCreators from "../../store/oits/action-creators";

class FtoAnalytics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      showFormTypeModal: false,
      selectedFto: '',
      selectedOit: '',
      selectedFtosGuids: [],
      selectedOitsGuids: [],
      selectedFormTypes: ['dor', 'dor2', 'dor3', 'dor3', 'rdor', 'dorr'],
      selectedQuestions: {},
      selectedQuestionIds: {},
      showQuestionsModal: false,
      questionsSet: false,
      showAllOits: false,
      trainingPhases: [],
      selectedPhasesMap: {},
    }
  }

  componentDidMount() {
    this.props.fetchFtos();
    this.props.loadOitsContainer(this.props.userContext.scope)
    if(this.oitsInProgress.length) {
      let oit = this.oitsInProgress[0]
      this.setState({
        selectedPhasesMap: oit.trainingPhases
            .filter(tp => tp.type !== 'orientation')
            .reduce((acc, tp) => ({
              ...acc,
              [tp.sequence]: true
            }), {}),
        trainingPhases: oit.trainingPhases
      })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.forms && !this.state.questionsSet) {
      this.setState({
        selectedQuestions: this.addQuestionsToFilter(this.currentQuestions),
        questionsSet: true
      })
    }

    if(this.oitsInProgress.length && !this.state.trainingPhases.length) {
      let oit = this.oitsInProgress[0]
      this.setState({
        selectedPhasesMap: oit.trainingPhases
            .filter(tp => tp.type !== 'orientation')
            .reduce((acc, tp) => ({
              ...acc,
              [tp.sequence]: true
            }), {}),
        trainingPhases: oit.trainingPhases
      })
    }
  }

  handleFilterClick() {
    this.setState({
      showQuestionsModal: true
    });
  }

  handleFormTypeClick() {
    this.setState({
      showFormTypeModal: true
    });
  }

  closeFormTypeModal(e) {
    this.setState({
      showFormTypeModal: false
    });
  }

  closeQuestionsModal(e) {
    this.setState({
      showQuestionsModal: false
    });
  }

  isFormTypeChecked(form) {
    return this.state.selectedFormTypes.includes(form.type)
  }

  onFormTypeSelectChange(checked, form) {
    let selectedFormTypes = [...this.state.selectedFormTypes];
    if(checked) {
      selectedFormTypes = [...selectedFormTypes.filter(f => f !== form.type), form.type];
    } else {
      selectedFormTypes = selectedFormTypes.filter(f => f !== form.type);
    }

    this.setState({
      selectedFormTypes
    }, () => {
      this.setState({
        selectedQuestions: this.addQuestionsToFilter(this.currentQuestions),
      })
    })
  }

  applyChanges() {
    this.setState({
      showFormTypeModal: false
    })
    // this.reloadAnalytics()
  }

  setSelectedFto(ftoId) {
    this.setState({
      selectedFtosGuids: [...this.state.selectedFtosGuids, ftoId]
    })
  }
  setSelectedOit(ftoId) {
    this.setState({
      selectedOitsGuids: [...this.state.selectedOitsGuids, ftoId]
    })
  }

  removeFto(ftoId) {
    this.setState({
      selectedFtosGuids: this.state.selectedFtosGuids.filter(f => f !== ftoId)
    })
  }
  removeOit(oitId) {
    this.setState({
      selectedOitsGuids: this.state.selectedOitsGuids.filter(o => o !== oitId)
    })
  }

  selectAllQuestions(value) {
    let questions = {};
    for (const property in this.state.selectedQuestions) {
      questions[property] = value;
    }

    this.setState({
      selectedQuestions: questions,
      selectAll: value,
      deselectAll: !value
    });
  }

  deselectAllQuestions(value) {
    let questions = {};
    for (const property in this.state.selectedQuestions) {
      questions[property] = !value;
    }

    this.setState({
      selectedQuestions: questions,
      selectAll: !value,
      deselectAll: value
    });
  }

  onQuestionChange(value, fieldKey) {
    let selectedQuestions = this.state.selectedQuestions;
    selectedQuestions[fieldKey] = value

    this.setState({
      selectedQuestions: selectedQuestions,
      selectAll: false,
      deselectAll: false
    });

  }

  addQuestionsToFilter(questions) {
    return Object.assign(questions.reduce((acc, question) => ({
      ...acc,
      [question.id]: true
    }), {}), this.state.selectedQuestions)
  }

  setShowAllOits(e) {
    this.setState({
      showAllOits: e.target.checked
    })
  }

  get selectedFtos() {
    return this.props.ftos ? this.props.ftos.filter(f => this.state.selectedFtosGuids.includes(f.guid)) : []
  }

  get selectedOits() {
    return this.props.oits ? this.props.oits.filter(f => this.state.selectedOitsGuids.includes(f.guid)) : []
  }

  get critiqueFormTypes() {
    return this.props.departmentSettings && this.props.departmentSettings.critiqueFormTypes ? this.props.departmentSettings.critiqueFormTypes : ['ftc'];
  }

  get currentForms() {
    if(!this.props.forms) {
      return []
    }

    return this.props.forms
      .filter(f => f.status === 'current')
      .filter(f => {
        if (this.critiqueFormTypes.includes(f.type)) {
          return this.props.canViewCritiqueForms;
        }
        return true
      })
  }

  get currentQuestions() {
    return this.currentForms
      .filter(f => this.isFormTypeChecked(f))
      .reduce((acc, form) => {
          return [
            ...acc,
            ...form.layout.filter(q => q.type === 'question' && (q.schema.startsWith('rating') || q.schema === 'pto-rating-multi'))
          ]
        }, [])
  }

  get filteredQuestions() {
    return this.currentQuestions.filter(q => this.state.selectedQuestions[q.id])
  }

  get oitsInProgress() {
    if (this.state.showAllOits) {
      return this.props.oits || []
    }
    return this.props.oits
      && this.props.oits.filter(o =>
        o.trainingPhases.find(tp => tp.status === 'opened')) || []
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.state.isLoading}>
        <div className="app-content-header">
          <h4 className="title">{this.props.ftoShortLabel} Analytics</h4>
        </div>
        <div className="fto-analytics app-content">
          <div className="form">
            <div style={{display: 'flex'}}>
              <div className="mr-2">
                <button className="button secondary" onClick={() => this.handleFormTypeClick()}>
                  <i className="fa fa-paperclip"/>
                  Form types
                </button>
              </div>

              <div className="ml-2 mr-2">
                <button className="button secondary" onClick={() => this.handleFilterClick()}>
                  <i className="fa fa-filter"/>
                  Filter questions
                </button>
              </div>

              <div className="form-group" style={{maxWidth: '50%', minWidth: '175px'}}>
                <Input
                  name="type"
                  onChange={event =>
                    this.setSelectedFto(event.target.value)
                  }
                  type="select"
                  value={''}
                >
                  <option
                    defaultValue={''}>{this.state.selectedFtosGuids.length ? `Add ${this.props.ftoShortLabel} to compare` : 'Select ' + this.props.ftoShortLabel}</option>
                  {this.props.ftos && this.props.ftos.map(fto => (
                    <option key={fto.guid} value={fto.guid}>{fto.getFullName()}</option>
                  ))}
                </Input>
              </div>

              {!!this.selectedFtos.length && <div className="form-group ml-2" style={{maxWidth: '50%', minWidth: '175px'}}>
                <Input
                  name="type"
                  onChange={event =>
                    this.setSelectedOit(event.target.value)
                  }
                  type="select"
                  value={''}
                >
                  <option
                    defaultValue={''}>{`Add ${this.props.oitShortLabel} to compare`}</option>
                  {this.oitsInProgress && this.oitsInProgress.map(oit => (
                    <option key={oit.guid} value={oit.guid}>{oit.getFullName()}</option>
                  ))}
                </Input>
              </div>}

              {!!this.selectedFtos.length && <div className="ml-2">
                <Checkbox checked={this.state.showAllOits} onChange={(e) => this.setShowAllOits(e)}
                          label={'Show all ' + this.props.oitShortLabel + 's'}/>
              </div>}

            </div>
          </div>
          {this.selectedFtos.length ? (
            <div className="form">
              <div className="selected-users">
                <div className="selected-users-header">Displaying report for users:</div>
                {this.selectedFtos.map((fto) => (
                  <div key={fto.guid} className="selected-user">
                    {fto.getFullName()}
                    <button className="button danger small" onClick={() => this.removeFto(fto.guid)}>
                      <i className="fa fa-trash-o mr-2"/>
                      Remove
                    </button>
                  </div>
                ))}
              </div>
              {this.selectedOits.length ? (
                <div className="selected-users">
                  <br />
                  <div className="selected-users-header">Displaying report for {this.props.oitShortLabel}:</div>
                  {this.selectedOits.map((oit) => (
                    <div key={oit.guid} className="selected-user">
                      {oit.getFullName()}
                      <button className="button danger small" onClick={() => this.removeOit(oit.guid)}>
                        <i className="fa fa-trash-o mr-2"/>
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          ) : null}

          <div className="selected-users">
            <br/>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
              {this.state.trainingPhases
                  .filter(tp => tp.type !== 'orientation')
                  .map(tp => (
                      <div key={tp.sequence} style={{marginRight: '10px'}}>
                        <Checkbox
                            label={tp.header}
                            checked={this.state.selectedPhasesMap[tp.sequence]}
                            onChange={e => this.setState({selectedPhasesMap: {...this.state.selectedPhasesMap, [tp.sequence]: e.target.checked}})}
                        />
                      </div>
                  ))}
            </div>
          </div>

          {this.selectedFtos.length ? (
            <FtoStatistics
              selectedQuestions={this.filteredQuestions}
              selectedFtos={this.selectedFtos}
              selectedOits={this.selectedOits}
              selectedPhasesMap={this.state.selectedPhasesMap}
            />
          ): null}
        </div>

        <Modal
          title="Choose Observations"
          isOpen={this.state.showQuestionsModal}
          onClose={(e) => this.closeQuestionsModal(e)}
          size="sm"
        >
          <div className="questions-container">
            <div className="select-all">
              <div className="btn-container">
                <button className="button secondary" onClick={() => this.selectAllQuestions(true)}>
                  Select All
                </button>
              </div>

              <div className="btn-container right">
                <button className="button secondary" onClick={() => this.deselectAllQuestions(true)}>
                  Deselect All
                </button>
              </div>
            </div>

            {this.currentQuestions.map(question => (
              <Checkbox
                key={question.id}
                checked={this.state.selectedQuestions[question.id]}
                label={question.ratingPrompt || question.prompt}
                onChange={(e) => {
                  this.onQuestionChange(e.target.checked, question.id)
                }}
              />
            ))}
          </div>
        </Modal>

        <Modal
          title="Choose form types to display"
          isOpen={this.state.showFormTypeModal}
          onClose={(e) => this.closeFormTypeModal(e)}
          size="sm"
        >
          <div className="p-3">
            {this.currentForms.map(form => (
              <Checkbox
                key={form.type}
                checked={this.isFormTypeChecked(form)}
                label={form.name}
                onChange={(e) => {
                  this.onFormTypeSelectChange(e.target.checked, form)
                }}
              />
            ))}
            <div>
              <button className="button primary mt-3" onClick={() => this.applyChanges()}>
                Apply changes
              </button>
            </div>
          </div>
        </Modal>
      </LoadingOverlay>
    )
  }
}

function mapStateToProps(state) {
  return {
    isLoading: state.ftos.isLoading,
    ftos: state.ftos.list,
    oits: state.oits.list,
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    departmentSettings: state.departmentSettings.settings,
    canViewCritiqueForms: departmentSettingsSelectors.canViewCritiqueForms(state),
    forms: state.forms.list,
    userContext: state.common.userContext
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchFtos: () => {
      return dispatch(ftosActionCreators.fetchFtos());
    },
    loadOitsContainer: (scope) => {
      return dispatch(oitsActionCreators.loadOitsContainer(scope));
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FtoAnalytics))
